import ajaxLoading from "@root/tabulator/CellFormatters/ajaxLoading";
import creatorFilter from "@root/tabulator/Filters/creator";
import minMaxDateFilter from "@root/tabulator/Filters/min-max-date";
import minMaxFilter from "@root/tabulator/Filters/min-max";
import beatingHeartFilter from "@root/tabulator/Filters/beating-heart";
import minMaxMoneyFilter from "@root/tabulator/Filters/min-max-money";
import moneyFilter from "@root/tabulator/Filters/money";
import useApi from "@apexl/icarus-core/src/services/api";
import useDropdownStore from "@root/store/useDropdownStore";

class TabulatorColumnMapper {
  constructor(column) {
    this.column = column;
  }

  static map(column) {
    const mapper = new TabulatorColumnMapper(column);

    return mapper._map();
  }

  _map() {
    const { ..._column } = this.column;
    if (_column.hasOwnProperty('ajax') && _column.ajax) {
      _column.formatter = ajaxLoading(_column.formatter);
    }

    if (_column.hasOwnProperty('headerFilter')) {
      const {
        headerFilterLiveFilter,
        headerFilter,
        headerFilterFunc,
        headerFilterParams,
      } = this.mapHeaderFilter(_column.headerFilter, _column.headerFilterFunc, _column.headerFilterLiveFilter, _column.headerFilterParams);

      _column.headerFilterLiveFilter = headerFilterLiveFilter;
      _column.headerFilter = headerFilter;
      _column.headerFilterFunc = headerFilterFunc;
      _column.headerFilterParams = headerFilterParams;
    }

    if (_column.hasOwnProperty('tooltip')) {
      _column.tooltip = this.mapTooltip(_column.tooltip);
    }

    if (_column.hasOwnProperty('hiddenTitle')) {
      if (_column.hiddenTitle) {
        _column.title = '';
      }
      delete _column.hiddenTitle;
    }


    return _column;
  }

  mapTooltip(tooltip) {
    let field;
    if (tooltip) {
      switch (typeof tooltip) {
        case 'string':
          return tooltip.replace(/\n/g, '<br />');

        case  'object':
          ({ field } = tooltip);

          // noinspection FallThroughInSwitchStatementJS
        case 'boolean':
          return (e, cell) => {
            field = field || cell.getField();
            return (cell.getRow().getData()[field] || '').replace(/\n/g, '<br />') || false;
          }

        default:
          return tooltip;
      }

    }
    return tooltip;
  }

  mapHeaderFilter(
      headerFilter,
      headerFilterFunc,
      headerFilterLiveFilter,
      headerFilterParams = {}
  ) {
    switch (headerFilter) {
      case 'min_max': {
        return {
          headerFilter: minMaxFilter,
          headerFilterLiveFilter: false,
          headerFilterFunc: 'between',
          headerFilterParams
        };
      }
      case 'min_max_date': {
        return {
          headerFilter: minMaxDateFilter,
          headerFilterLiveFilter: false,
          headerFilterFunc: 'between',
          headerFilterParams
        };
      }
      case 'min_max_money': {
        return {
          headerFilter: minMaxMoneyFilter,
          headerFilterLiveFilter: false,
          headerFilterFunc: 'between',
          headerFilterParams
        };
      }
      case 'money': {
        return { headerFilter: moneyFilter, headerFilterLiveFilter: false, headerFilterFunc: '=', headerFilterParams };
      }
      case 'creator': {
        return {
          headerFilter: creatorFilter,
          headerFilterLiveFilter: false,
          headerFilterFunc: 'creator',
          headerFilterParams
        };
      }
      case 'list': {
        if (headerFilterParams.valuesURL) {
          const valuesURL = headerFilterParams.valuesURL;
          delete headerFilterParams.valuesURL;

          const api = useApi();
          const { getDropdown, hasDropdown, setDropdown } = useDropdownStore();

          headerFilterParams.valuesLookup = async () => {
            if (!hasDropdown(valuesURL)) {
              const data = await api.get(valuesURL);
              setDropdown(valuesURL, data);
            }

            return getDropdown(valuesURL);
          }
        }

        return { headerFilter: 'list', headerFilterLiveFilter: false, headerFilterFunc: '=', headerFilterParams };
      }

      case 'beating_heart':
        return {
          headerFilter: beatingHeartFilter,
          headerFilterLiveFilter: false,
          headerFilterFunc,
          headerFilterParams
        };

      default:
        return { headerFilter, headerFilterLiveFilter: false, headerFilterFunc, headerFilterParams };
    }
  }
}

export default TabulatorColumnMapper;
